import Frame from '../layout/Frame';
import Panel from '../layout/Panel';
import Contact from '../components/Contact/Contact';

const ContactUsUser = () => {
  return (
    <Frame>
      <Panel>
        <Contact />
      </Panel>
    </Frame>
  );
};

export default ContactUsUser;
